import { Button, Form, Slider, Space } from "antd";
// import BasePanel from "./BasePanel"
import FormItem from "antd/es/form/FormItem";
import { useEffect, useState } from "react";

function BlurPanel(props) {

    const [blurSize, setBlurSize] = useState(0);

    useEffect(() => {
        if (props.tool === "adjustment" && props.subTool === "adjustment-blur") {
            console.log("BlurPanel: ", props);
            window.PSMan_onToolEvents = function (nm, obj) {
                console.log("PSMan_onToolEvents(blur)>>>>>>:: ", nm, obj);
            }

            let cfg = window.PSMan?.getInstance().toolManager().current()?.getConfig();
            if (cfg != null) {
                console.log("BlurPanel: init config:", cfg);
                // setVibrance(cfg.vibrance);
                setBlurSize(cfg.blurSize);
            }
        }
    }, [props]);


    const blurSize_onChange = (newValue) => {
        if (newValue == null) { return; }
        setBlurSize(newValue);
        window.PSMan?.getInstance().toolManager().current().setConfig({ blur: newValue });
    };

    const reset_onClick = () => {
        // setVibrance(0);
        setBlurSize(0);
        window.PSMan?.getInstance().toolManager().current().setConfig({ vibrance: 0, blur: 0 });
    }

    const apply_onClick = () => {
        window.PSMan?.getInstance().toolManager().current().sendAction("apply", null);
        // setVibrance(0);
        setBlurSize(0);
        props.onApply();
    }


    return (
        <>
            <FormItem label="强度">
                <Slider min={0} max={100} value={blurSize} onChange={blurSize_onChange} />
            </FormItem>

            <Form.Item>
                <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                    <Button size="small" onClick={reset_onClick}>重置</Button>
                    <Button size="small" onClick={apply_onClick} type="primary">确定</Button>
                </Space>
            </Form.Item>
        </>
    );
}

export default BlurPanel;